import React from "react";
import { ArrowUpRight, Check } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function Personalization() {
  const { t } = useLang();
  return (
    <section
      id="personalization"
      className="section-y bg-brand-ink text-white relative overflow-hidden grain"
      data-testid="personalization-section"
    >
      <div aria-hidden className="absolute inset-0 -z-0 opacity-40">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-brand-champagne/10 blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-[600px] h-[600px] rounded-full bg-brand-silver/10 blur-3xl" />
      </div>

      <div className="container-x relative z-10 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <span className="overline !text-brand-champagne">{t.personalization.overline}</span>
          <h2 className="mt-5 text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-white text-balance">
            {t.personalization.title}
          </h2>
          <p className="mt-6 text-base md:text-lg text-white/70 leading-relaxed text-pretty">
            {t.personalization.body}
          </p>
          <a
            href="/#contact"
            className="mt-10 inline-flex btn-on-dark"
            data-testid="personalization-cta"
          >
            {t.personalization.cta}
            <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>

        <div className="lg:col-span-7">
          <div className="grid sm:grid-cols-2 gap-3 md:gap-4">
            {t.personalization.items.map((it, i) => (
              <div
                key={i}
                className="rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-sm p-5 flex items-start gap-3 transition-colors duration-300 hover:border-brand-champagne/60"
                data-testid={`personalization-item-${i}`}
              >
                <span className="mt-0.5 grid place-items-center h-6 w-6 rounded-full bg-brand-champagne text-brand-ink shrink-0">
                  <Check className="h-3.5 w-3.5" strokeWidth={3} />
                </span>
                <span className="text-sm text-white/85 leading-relaxed">{it}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
